import React, { useState } from "react";
import { message } from "antd";
import { Button } from "antd";
import { multiImageZipKey } from "../../../../core/utils/dataloading/multiImageZipKey";

const DownloadAdUnitButton = ({
  creativeKeys,
  disabled,
  label = "Download Selected Creative/s",
  onDownloadComplete,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      await multiImageZipKey(
        `Creatives (${creativeKeys.length} creative)`,
        creativeKeys
      );
      if (onDownloadComplete) onDownloadComplete();
      message.success(`Successfully prepared download for ${creativeKeys.length} creative(s)`);
    } catch (error) {
      message.error('Download failed. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Button
      type="primary"
      size="large"
      disabled={!creativeKeys || creativeKeys.length === 0 || disabled || isDownloading}
      loading={isDownloading}
      onClick={handleDownload}
    >
      {label}
    </Button>
  );
};

export default DownloadAdUnitButton;
